import { setCookie } from 'src/misc/utilities';

export const setDarkModeCookie = (user: { dark_mode?: boolean }) => {
  if ('dark_mode' in user) {
    setCookie('dark_mode', user.dark_mode, 90000);
  }
};
